import script from "./RoutesView.vue?vue&type=script&setup=true&lang=js"
export * from "./RoutesView.vue?vue&type=script&setup=true&lang=js"

import "./RoutesView.vue?vue&type=style&index=0&id=3a165e9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a165e9c"]])

export default __exports__